module.exports = __webpack_public_path__ + "media/react/assets/GoalCycle-2adbb290eb906d397e42f0cda90c1a05.svg";